<template>
  <layout>
    <div class="page-view">
      <banner
        :img="contList.picUrl"
        :title="contList.menuName"
        :subtitle="contList.menuNameEn" />
      <div
        class="scheme phone-hidden"
        :key="c.id"
        v-for="(c, i) in contList.menuModule">
        <f-title
          :title="c.title"
          :subtitle="c.titleEn" />
        <div class="scheme-desc">{{ c.content }}</div>
        <div
          class="scheme-modules"
          v-for="(d, j) in c.detailsList"
          @click="goEnterprise(handleEnterprise(i, j, d.id))"
          :key="d.id">
          <img
            :src="d.imgUrl"
            alt="" />
          <div class="scheme-modules-cont">
            <div class="title">{{ d.title }}</div>
            <div class="more">
              了解更多<span class="iconfont icon-right-1-copy"></span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="scheme ipad-hidden"
        :key="i"
        v-for="(c, i) in contList.menuModule">
        <f-title
          :title="c.title"
          :subtitle="c.titleEn" />
        <div class="scheme-desc">{{ c.content }}</div>
        <div
          class="scheme-module1"
          v-if="i === 0">
          <div class="left">
            <div
              class="cont"
              @click="goEnterprise(handleEnterprise(i, j, d.id))"
              v-for="(d, j) in c.detailsList.slice(0, 1)"
              :key="j">
              <div class="cont-kv">
                <img
                  :src="d.imgUrl"
                  alt="" />
              </div>
              <div class="cont-txt">
                <div class="title">{{ d.title }}</div>
                <div class="more">
                  了解更多<span class="iconfont icon-right-1-copy"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div
              class="cont"
              @click="goEnterprise(handleEnterprise(i, j + 1, d.id))"
              v-for="(d, j) in c.detailsList.slice(1)"
              :key="j">
              <div class="cont-kv">
                <img
                  :src="d.imgUrl"
                  alt="" />
              </div>
              <div class="cont-txt">
                <div class="title">{{ d.title }}</div>
                <div class="more">
                  了解更多<span class="iconfont icon-right-1-copy"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="scheme-module2"
          v-else-if="i === 1">
          <div
            class="cont"
            @click="goEnterprise(handleEnterprise(i, j, d.id))"
            v-for="(d, j) in c.detailsList"
            :key="j">
            <div class="cont-kv">
              <img
                :src="d.imgUrl"
                alt="" />
            </div>
            <div class="cont-txt">
              <div class="title">{{ d.title }}</div>
              <div class="more">
                了解更多<span class="iconfont icon-right-1-copy"></span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="scheme-module3"
          v-else>
          <div
            class="cont"
            @click="goEnterprise(handleEnterprise(i, j, d.id))"
            v-for="(d, j) in c.detailsList"
            :key="j">
            <div class="cont-kv">
              <img
                :src="d.imgUrl"
                alt="" />
            </div>
            <div class="cont-txt">
              <div class="title">{{ d.title }}</div>
              <div class="more">
                了解更多<span class="iconfont icon-right-1-copy"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import FTitle from '@/components/title.vue';
import Layout from '@/components/moblie/Layout.vue';
import Banner from '@/components/banner.vue';
export default {
  components: { Layout, Banner, FTitle },
  props: {
    contList: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    handleEnterprise(m, p, id) {
      let list = [
        {
          m: 0,
          p: 0,
          idNum: '2-1',
          url: 'enterpriseHome/enterpriseMobileSecurity',
          id,
        },
        {
          m: 0,
          p: 1,
          idNum: '2-3',
          url: 'enterpriseHome/enterpriseMobileOffice',
          id,
        },
        {
          m: 0,
          p: 2,
          idNum: '2-2',
          url: 'enterpriseHome/enterpriseMobileComm',
          id,
        },
        {
          m: 0,
          p: 3,
          idNum: '2-4',
          url: 'enterpriseHome/enterpriseSmartOffice',
          id,
        },
        {
          m: 1,
          p: 0,
          idNum: '2-5',
          url: 'enterpriseHome/enterpriseEMM',
          id,
        },
        {
          m: 1,
          p: 1,
          idNum: '2-6',
          url: 'enterpriseHome/enterprisePrivatizationOA',
          id,
        },
        {
          m: 1,
          p: 2,
          idNum: '2-7',
          url: 'enterpriseHome/enterpriseDataSecu',
          id,
        },
        {
          m: 2,
          p: 0,
          idNum: '2-8',
          url: 'enterpriseHome/enterpriseProcurement',
          id,
        },
      ];
      return list.find((item) => {
        return item.m === m && item.p === p;
      });
    },
    goEnterprise(row) {
      this.$router.push({
        name: row.url,
        params: { id: row.id },
      });
      this.$store.commit('changeTabCheck', {
        idNum: row.idNum,
        sumName: '',
      });
      this.$store.state.enterp_somFlg = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
/* phone */
@media (max-width: $phone-max-size) {
  $container-width: 335px;
  .page-view {
    .scheme {
      width: $container-width;
      margin: 20px auto;
      &-desc {
        font-weight: 400;
        font-size: 9px;
        color: #666666;
        text-align: center;
        margin-bottom: 27px;
      }
      &-modules {
        position: relative;
        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          margin-bottom: 25px;
        }
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.7) 100%
          );
        }
        &-cont {
          position: absolute;
          font-weight: 500;
          font-size: 15px;
          color: #ffffff;
          left: 15px;
          bottom: 17px;
          .more,
          .iconfont {
            font-weight: 400;
            font-size: 10px;
            color: #ffffff;
            opacity: 0.8;
          }
        }
      }
    }
  }
}
/* ipad */
@media (min-width: $ipad-min-size) and (max-width: $ipad-max-size) {
  $container-width: 700px;
  .page-view {
    .scheme {
      width: $container-width;
      margin: 20px auto;
      &-desc {
        font-weight: 400;
        font-size: 9px;
        color: #666666;
        text-align: center;
        margin-bottom: 27px;
      }
      &-module1 {
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;
        .cont {
          position: relative;
          &::before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0.7) 100%
            );
          }
          &-txt {
            width: 100%;
            position: absolute;
            left: 11px;
            bottom: 14px;
            .title {
              font-weight: bold;
              font-size: 14px;
              color: #ffffff;
              margin-bottom: 4px;
            }
            .more {
              font-weight: 400;
              font-size: 12px;
              color: #ffffff;
              opacity: 0.8;
              .iconfont {
                font-size: 12px;
              }
            }
          }
        }
        .left {
          width: 32%;
          .cont {
            img {
              width: 100%;
              height: 320px;
              object-fit: cover;
            }
            &-txt {
            }
          }
        }
        .right {
          width: 66%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-content: space-between;
          .cont {
            width: 48%;
            img {
              width: 100%;
              height: 150px;
              object-fit: cover;
            }
            &:nth-of-type(1) {
              width: 100%;
              img {
                width: 100%;
                height: 150px;
                object-fit: cover;
              }
            }
          }
        }
      }
      &-module2 {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 40px;
        justify-content: space-between;
        .cont {
          width: 32%;
          position: relative;
          &::before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0.7) 100%
            );
          }
          img {
            width: 100%;
            height: 150px;
            object-fit: cover;
          }
          &-txt {
            width: 100%;
            position: absolute;
            left: 11px;
            bottom: 14px;
            .title {
              font-weight: bold;
              font-size: 14px;
              color: #ffffff;
              margin-bottom: 4px;
            }
            .more {
              font-weight: 400;
              font-size: 12px;
              color: #ffffff;
              opacity: 0.8;
              .iconfont {
                font-size: 12px;
              }
            }
          }
        }
      }
      &-module3 {
        margin-bottom: 40px;
        .cont {
          position: relative;
          &::before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0.7) 100%
            );
          }
          img {
            width: 100%;
            height: 240px;
            object-fit: cover;
          }
          &-txt {
            width: 100%;
            position: absolute;
            left: 11px;
            bottom: 14px;
            .title {
              font-weight: bold;
              font-size: 14px;
              color: #ffffff;
              margin-bottom: 4px;
            }
            .more {
              font-weight: 400;
              font-size: 12px;
              color: #ffffff;
              opacity: 0.8;
              .iconfont {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
